<script>
// import Vue from 'vue'
// Import UI components
import Layout from '@layouts/report.vue'
// import Grid from '@components/grid.vue'



// Import ThirdParty UI Components
import HeatMapChart from '@components/charts/heatmapChart.vue'
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
// Import Deps
import axios from 'axios'
import moment from 'moment'
import _ from 'underscore'

// Import helpers
// import { sortData, pipe } from '@utils/helpers.js'

// export const remapData = (data) =>
//   data.map((obj, index) => {
//     return { value: obj[key1], name: obj[key2] }
//   })

export const pipe = (...functions) => (value) => {
  return functions.reduce((currentValue, currentFunction) => {
    return currentFunction(currentValue)
  }, value)
}

function getDates(startDate, endDate) {
  var dateArray = []
  var currentDate = moment(startDate)
  var stopDate = moment(endDate)
  while (currentDate <= stopDate) {
    dateArray.push(
      moment(currentDate)
        .format('DDMMMYY')
        .toUpperCase()
    )
    currentDate = moment(currentDate).add(1, 'days')
  }
  return dateArray
}

export default {
  page() {
    return {
      title: 'Weekly Profile Report',
      meta: [
        {
          name: 'description',
          content: ``,
        },
      ],
    }
  },
  components: {
    Layout,

    HeatMapChart,
    Loading,
  },
  props: {},
  data() {
    return {
      chartData: [],
      max: 0,
      availableKeys: ['TotalTransactions', 'TotalAgent', 'TotalPax'],
      selectedKey: 'TotalPax',
      days: ['30JAN20', '31JAN20'],
      hours: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
      ],
      lastUpdated: [{ type: 'agentTotals', timestamp: null }],
      isLoading: false,
      error: null,
      sideBarVisible: true,
      natFilter: null,

      othersLimit: null,
      params: {},
      paramsSchema: [
        {
          fieldType: 'MultiSelect',
          placeholder: 'Select Carriers',
          multi: true,
          value: null,
          name: 'carrier',
          label: 'Carriers',
        },
      ],
    }
  },

  computed: {
    carrierChoice() {
      return this.$store.getters['auth/getCarrierChoice']
    },

    dateRange() {
      return this.$store.getters['report/getSelectedDateRange']
    },
    datesArray() {
      return getDates(
        this.dateRange.startDate,
        this.dateRange.endDate
      ).reverse()
    },
  },
  watch: {
    dateRange: {
      deep: true,
      immediate: true,
      handler(dateRange) {
        this.getData()
      },
    },
    params: {
      deep: true,
      handler() {
        this.getData()
      },
    },
    selectedKey: {
      handler() {
        this.getData()
      },
    },
  },
  beforeCreate() {
    this.$store.dispatch('report/SET_SELECTED_DATE_RANGE', {
      startDate: moment().add(-8, 'd'),
      endDate: moment().add(-1, 'd'),
    })
  },
  mounted() {
    // this.getData()

    this.paramsSchema[0].options = this.carrierChoice
  },
  methods: {
    moment(date, format) {
      return moment(date).format(format)
    },
    sortData(data) {
      return data.sort((a, b) => {
        var x = a[this.sortKey]
        var y = b[this.sortKey]
        return x < y ? -1 : x > y ? 1 : 0
      })
    },
    getData() {
      this.isLoading = true

      this.error = null
      //   Setup Report Params
      const startDate = moment(this.dateRange.startDate).format('DDMMMYY')
      const endDate = moment(this.dateRange.endDate).format('DDMMMYY')
      const carriers =
        this.params && this.params.carrier
          ? this.params.carrier.join(',')
          : 'all'
      //   @@TODO - Config file for webapi address!!
      axios
        .get(
          `${this.$config.apiBaseUrl}agentTotals/ckd/carrier/${carriers}/start/${startDate}/end/${endDate}/timeperiod/60`
        )
        .then((response) => {
          const data = response.data.Results[0]
          // Update the timestamp
          const paxlist = this.lastUpdated.findIndex(
            (obj) => obj.type === 'agentTotals'
          )
          this.lastUpdated[paxlist].timestamp = response.data.Timestamp

          this.max = _.max(data, (obj) => {
            return obj[this.selectedKey]
          })[this.selectedKey]

          const heatmapData = []

          data.forEach((date) => {
            const day = moment(date.DatePeriod).format('DDMMMYY')
            const hrs = moment(date.DatePeriod).format('HH')

            const dayIdx = this.datesArray.findIndex(
              (d) => d === day.toUpperCase()
            )
            const hrsIdx = this.hours.findIndex((h) => h === hrs)
            heatmapData.push([hrsIdx, dayIdx, date[this.selectedKey]])
          })

          this.chartData = heatmapData
          // Assign the data from the response to reactive var
        })
        .catch((error) => {
          this.error = error.response
          console.log('here ---> ', error)
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<template>
  <Layout
    :params-schema="paramsSchema"
    :params="params"
    :last-updated="lastUpdated"
    :error="error"
  >
    <div class="mr-1 mt-1 ml-1 full">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-6">
              <h5 class="card-title">Weekly Check-in Activity</h5>
              <p
                >This report shows the shows the total number of check-in
                transactions, checked in passengers and active agents. The
                report can be filtered by carrier.</p
              >
            </div>
            <div class="col-4 text-right"></div>
            <div class="col-2 text-right">
              <div>
                <b-form-select
                  v-model="selectedKey"
                  plain
                  :options="availableKeys"
                  class="mb-1 form-control form-control-xs"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled
                      >-- Please select an option --</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>

          <HeatMapChart
            :data-key="selectedKey"
            :chart-data="chartData"
            :days="datesArray"
            :max="max"
            :hours="hours"
          ></HeatMapChart>
        </div>
      </div>
    </div>
    <Loading></Loading>
  </Layout>
</template>

<style scoped></style>
